import { useSelector } from 'react-redux';
import {
  replaceDomainForCacheKey,
  useErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';

import { getBdaasUserLoungeBookingUrl } from '@/selectors/bdaasSelectors';
import { useCenturionOrActiveToken } from '../memberHooks';

export const useBdaasUserLoungeBooking = () => {
  const url = useSelector(getBdaasUserLoungeBookingUrl);
  const accountToken = useCenturionOrActiveToken();

  return useErrorOnNotOkFetchye(
    url,
    {
      mapKeyToCacheKey: replaceDomainForCacheKey('bdaas'),
      credentials: 'include',
      defer: !accountToken, // Defer the fetch until the user is logged in i.e. an account token is available
      headers: {
        ...(accountToken && {
          account_token: accountToken,
        }),
      },
    },
    {
      reporting: {
        url,
        collectionMethod: 'useBdaasUserLoungeBooking',
        moduleId: 'travel-lounge-finder-root',
      },
    }
  );
};
